import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { FindClassificationTypesParams } from './classificationTypes.types';

export const getFindClassificationTypesKey = (
  params: FindClassificationTypesParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CLASSIFICATION_TYPES, undefined, params];

export const getFindClassificationTypesNoRbacKey = (
  params: FindClassificationTypesParams,
): UseDataQuery['queryKey'] => [DataQueryKey.CLASSIFICATION_TYPES_NO_RBAC, undefined, params];
